import { j as n } from "../../_virtual/jsx-runtime.js";
import { c as m } from "../../_virtual/compiler-runtime.js";
import { cn as f } from "../../utils/cn.js";
function p(o) {
  const e = m.c(14);
  let l, t, s;
  e[0] !== o ? ({
    className: l,
    rootClassName: s,
    ...t
  } = o, e[0] = o, e[1] = l, e[2] = t, e[3] = s) : (l = e[1], t = e[2], s = e[3]);
  let a;
  e[4] !== s ? (a = f("relative w-full overflow-auto", s), e[4] = s, e[5] = a) : a = e[5];
  let i;
  e[6] !== l ? (i = f("w-full border-collapse", l), e[6] = l, e[7] = i) : i = e[7];
  let r;
  e[8] !== t || e[9] !== i ? (r = /* @__PURE__ */ n.jsx("table", { className: i, ...t }), e[8] = t, e[9] = i, e[10] = r) : r = e[10];
  let c;
  return e[11] !== a || e[12] !== r ? (c = /* @__PURE__ */ n.jsx("div", { className: a, children: r }), e[11] = a, e[12] = r, e[13] = c) : c = e[13], c;
}
function d(o) {
  const e = m.c(8);
  let l, t;
  e[0] !== o ? ({
    className: l,
    ...t
  } = o, e[0] = o, e[1] = l, e[2] = t) : (l = e[1], t = e[2]);
  let s;
  e[3] !== l ? (s = f("border-b", l), e[3] = l, e[4] = s) : s = e[4];
  let a;
  return e[5] !== t || e[6] !== s ? (a = /* @__PURE__ */ n.jsx("thead", { className: s, ...t }), e[5] = t, e[6] = s, e[7] = a) : a = e[7], a;
}
function b(o) {
  const e = m.c(8);
  let l, t;
  e[0] !== o ? ({
    className: l,
    ...t
  } = o, e[0] = o, e[1] = l, e[2] = t) : (l = e[1], t = e[2]);
  let s;
  e[3] !== l ? (s = f("", l), e[3] = l, e[4] = s) : s = e[4];
  let a;
  return e[5] !== t || e[6] !== s ? (a = /* @__PURE__ */ n.jsx("tbody", { className: s, ...t }), e[5] = t, e[6] = s, e[7] = a) : a = e[7], a;
}
function u(o) {
  const e = m.c(10);
  let l, t, s;
  e[0] !== o ? ({
    className: l,
    interactive: s,
    ...t
  } = o, e[0] = o, e[1] = l, e[2] = t, e[3] = s) : (l = e[1], t = e[2], s = e[3]);
  const i = (s === void 0 ? !1 : s) && "transition-colors hover:bg-neutral-container cursor-pointer";
  let r;
  e[4] !== l || e[5] !== i ? (r = f("border-b", i, "data-[state=selected]:bg-neutral-container-emphasis", l), e[4] = l, e[5] = i, e[6] = r) : r = e[6];
  let c;
  return e[7] !== t || e[8] !== r ? (c = /* @__PURE__ */ n.jsx("tr", { className: r, ...t }), e[7] = t, e[8] = r, e[9] = c) : c = e[9], c;
}
function N(o) {
  const e = m.c(8);
  let l, t;
  e[0] !== o ? ({
    className: l,
    ...t
  } = o, e[0] = o, e[1] = l, e[2] = t) : (l = e[1], t = e[2]);
  let s;
  e[3] !== l ? (s = f("min-h-12 p-3 text-left align-middle text-caption text-muted", "[&:has([role=checkbox])]:pr-0", l), e[3] = l, e[4] = s) : s = e[4];
  let a;
  return e[5] !== t || e[6] !== s ? (a = /* @__PURE__ */ n.jsx("th", { className: s, ...t }), e[5] = t, e[6] = s, e[7] = a) : a = e[7], a;
}
function x(o) {
  const e = m.c(8);
  let l, t;
  e[0] !== o ? ({
    className: l,
    ...t
  } = o, e[0] = o, e[1] = l, e[2] = t) : (l = e[1], t = e[2]);
  let s;
  e[3] !== l ? (s = f("p-3 align-middle [&:has([role=checkbox])]:pr-0", l), e[3] = l, e[4] = s) : s = e[4];
  let a;
  return e[5] !== t || e[6] !== s ? (a = /* @__PURE__ */ n.jsx("td", { className: s, ...t }), e[5] = t, e[6] = s, e[7] = a) : a = e[7], a;
}
p.displayName = "Table";
const y = Object.assign(p, {
  Header: d,
  Body: b,
  Row: u,
  HeaderCell: N,
  Cell: x
});
d.displayName = "Table.Header";
b.displayName = "Table.Body";
u.displayName = "Table.Row";
N.displayName = "Table.HeaderCell";
x.displayName = "Table.Cell";
export {
  y as Table
};
